module.exports = __webpack_public_path__ + "static/img/consumer-h5-6.1756e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/consumer-h5-6.png
// module id = aXR/
// module chunks = 34